import {
  OnComplexSettingsModel,
  SiteSettingOptions,
} from "src/app/api/api-types";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<OnComplexSettingsModel>();

export class OnComplexSettings {
  public constructor(args: ClassProperties<OnComplexSettings>) {
    this.actualTemperature = args.actualTemperature;
    this.bolNumber = args.bolNumber;
    this.cdlNumber = args.cdlNumber;
    this.driverName = args.driverName;
    this.driverNumber = args.driverNumber;
    this.fuelLevel = args.fuelLevel;
    this.liveTrailerCDLNumber = args.liveTrailerCDLNumber;
    this.liveTrailerDriverName = args.liveTrailerDriverName;
    this.liveTrailerDriverNumber = args.liveTrailerDriverNumber;
    this.sealNumber = args.sealNumber;
    this.sealIntact = args.sealIntact;
    this.sealMatchesBOL = args.sealMatchesBOL;
    this.shippingNumber = args.shippingNumber;
    this.setTemperature = args.setTemperature;
    this.trailerNumber = args.trailerNumber;
  }

  @api() public readonly actualTemperature: SiteSettingOptions;
  @api() public readonly bolNumber: SiteSettingOptions;
  @api() public readonly cdlNumber: SiteSettingOptions;
  @api() public readonly driverName: SiteSettingOptions;
  @api() public readonly driverNumber: SiteSettingOptions;
  @api() public readonly fuelLevel: SiteSettingOptions;
  @api() public readonly liveTrailerCDLNumber: SiteSettingOptions;
  @api() public readonly liveTrailerDriverName: SiteSettingOptions;
  @api() public readonly liveTrailerDriverNumber: SiteSettingOptions;
  @api() public readonly sealNumber: SiteSettingOptions;
  @api() public readonly sealIntact: SiteSettingOptions;
  @api() public readonly sealMatchesBOL: SiteSettingOptions;
  @api() public readonly shippingNumber: SiteSettingOptions;
  @api() public readonly setTemperature: SiteSettingOptions;
  @api() public readonly trailerNumber: SiteSettingOptions;
}
